<div>
  <div *ngIf="!(meteringPoint$|async)">
    <app-spinner></app-spinner>
  </div>
  <div *ngIf="(meteringPoint$|async)">
    <h1>
      {{(meteringPoint$|async).name}}
    </h1>

    <div class="metering-point-item__back" *ngIf="showRouterLink">
      <a *ngIf="!selectedContractId && !selectedServiceAgreementId" [routerLink]="['/secure/meteringpoints/']" id="back_btn">
        <i class="material-icons">
          arrow_back
        </i>{{'metering.item.back'|translate}}
      </a>
      <a *ngIf="selectedServiceAgreementId && allMeteringPointsCount > 1" [routerLink]="['/secure/products/serviceagreements/' + selectedServiceAgreementId]" id="back_btn">
        <i class="material-icons">
          arrow_back
        </i>{{'metering.item.back_service_agreement'|translate}}
      </a>
      <a *ngIf="selectedServiceAgreementId && allMeteringPointsCount === 1" [routerLink]="['/secure/products']" id="back_btn">
        <i class="material-icons">
          arrow_back
        </i>{{'metering.item.back_service_agreement'|translate}}
      </a>
      <a *ngIf="selectedContractId && !selectedServiceAgreementId" [routerLink]="['/secure/contracts/' + selectedContractId]" id="back_btn">
        <i class="material-icons">
          arrow_back
        </i>{{'metering.item.back_contract'|translate}}
      </a>
    </div>

    <!-- Show contextual BannerMassages -->
    <app-contextual-system-message-pane></app-contextual-system-message-pane>

  </div>
  <div *ngIf="(meteringPoint$|async)">
    <mat-tab-group [selectedIndex]="selectedIndex$|async" (selectedIndexChange)="onTabIndexChange($event)" dynamicHeight mat-stretch-tabs="false">
      <mat-tab label="{{'metering.item.tabs.title_overview'|translate}}">
        <app-metering-point-item-pane 
        [userType]="userType$|async" 
        [filterArea]="'Meteringpoints'" 
        [userInfo]="userInfo$ | async" 
        [meteringPoint]="(meteringPoint$|async)" 
        [meteringPoints]="(meteringPoints$|async)" 
        [customer]="customer$|async"
        [contract]="(contract$ | async)"
        [periodData$]="periodData$"
        [isWhiteLabel]="isWhiteLabel" 
        >
      </app-metering-point-item-pane>
      </mat-tab>
      <mat-tab [disabled]="isWhiteLabel" label="{{'metering.item.tabs.title_meterings'|translate}}">
        <app-metering-point-metering-pane [userInfo]="userInfo$ | async" [meteringPoint]="(meteringPoint$|async)"></app-metering-point-metering-pane>
      </mat-tab>
      <mat-tab  [disabled]="isWhiteLabel" *ngIf="(meteringPoint$|async).type ==='LOG'"
        label="{{'metering.item.tabs.title_logical'|translate}}">
        <app-metering-point-logical-pane [userInfo]="userInfo$ | async" [meteringPoint]="(meteringPoint$|async)"></app-metering-point-logical-pane>
      </mat-tab>
      <mat-tab [disabled]="isWhiteLabel" label="{{'metering.item.tabs.title_functionalcontrol'|translate}}">
        <app-metering-point-function-control-pane [userInfo]="userInfo$ | async" [meteringPoint]="(meteringPoint$|async)"></app-metering-point-function-control-pane>
      </mat-tab>
    </mat-tab-group>
  </div>
